import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ed } from '../../lib/editTexts';
import { slotUrl, useWebsiteImages } from '../../lib/publicContent';

// Menuepunkte: gleiche Kennungen wie im Handy-Menue (MobileLayout).
const LINKS = [
  { to: '/', key: 'nav.home' },
  { to: '/about', key: 'nav.about' },
  { to: '/opfer', key: 'nav.giving' },
  { to: '/gebet', key: 'nav.prayer' },
];

export default function PublicNav() {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();
  const slots = useWebsiteImages();

  return (
    <nav className="kac-nav">
      <Link to="/" className="kac-nav-logo">
        <img src={slotUrl(slots, 'brand.logo', 0, '/kac-assets/KAC-Badge.png')} alt={t('nav.brand')} style={{ height: 40 }} data-slot="brand.logo" />
        <span {...ed('nav.brand')} style={{ fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 700, fontSize: 19, color: '#26211C' }}>
          {t('nav.brand')}
        </span>
      </Link>

      <div className="kac-nav-links">
        {LINKS.map(({ to, key }) => (
          <Link
            key={to}
            to={to}
            className={`kac-nav-link${pathname === to ? ' active' : ''}`}
            {...ed(key)}
          >
            {t(key)}
          </Link>
        ))}
      </div>

      <div className="kac-nav-right">
        <div className="kac-nav-lang">
          <button
            type="button"
            className={i18n.language?.startsWith('de') ? 'on' : ''}
            aria-pressed={i18n.language?.startsWith('de') ? 'true' : 'false'}
            aria-label={'Deutsch'}
            onClick={() => i18n.changeLanguage('de')}
            style={{ background: 'none', border: 0, font: 'inherit' }}
          >DE</button>
          <span style={{ color: 'rgba(120,100,70,0.35)' }}>/</span>
          <button
            type="button"
            className={i18n.language?.startsWith('en') ? 'on' : ''}
            aria-pressed={i18n.language?.startsWith('en') ? 'true' : 'false'}
            aria-label={'English'}
            onClick={() => i18n.changeLanguage('en')}
            style={{ background: 'none', border: 0, font: 'inherit' }}
          >EN</button>
        </div>

      </div>
    </nav>
  );
}
